import { type PropsWithChildren, useEffect, useMemo, useState } from 'react';

import { type MsTeams, MsTeamsContext } from './MsTeamsContext';
import { popUrlParam } from '../utils/url';

export const MsTeamsProvider = ({ children }: PropsWithChildren<{}>) => {
    const [msToken, setMSToken] = useState<MsTeams['msToken']>();

    useEffect(() => {
        const msTokenParam = popUrlParam('msToken');

        if (msTokenParam) {
            setMSToken(msTokenParam);
        }
    }, []);

    const value = useMemo<MsTeams>(() => ({ msToken }) satisfies MsTeams, [msToken]);

    return <MsTeamsContext.Provider value={value}>{children}</MsTeamsContext.Provider>;
};
